// extracted by mini-css-extract-plugin
export default {"title":"Titles_title__S5N+l"};